import React from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { onLCP, onINP, onCLS } from "web-vitals";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

onCLS(console.log);
onINP(console.log);
onLCP(console.log);
